<template>
    <div id="joinUs">
        <div class="leftNav">
            <div class="navBox" v-for="(item,index) in navData" :key="index"
                 :class="navIndex===index ? 'activeC' : '' "
                 @click="navEvent(index)">
                <span></span>
                {{item.navName}} {{navIndex===index ? `(${workData.length})` : ''}}
            </div>
        </div>
        <div class="rightCon">
            <div class="workList" v-for="(item,index) in workData" :key="index" @click="showValEvent(item)">
                <div class="workTitle" :class="item.flag ? 'activeT' : '' ">{{item.title}}</div>
                <div class="dVal" v-show="!item.flag">
                    {{item.dVal}}
                </div>
                <div style="" v-for="(val,idx) in item.lVal" :key="idx" v-show="item.flag">
                    <div class="lValWrap">
                        <div class="lValBox">
                            <div class="lValTitle">{{val.name}}</div>
                            <div class="lValText">
                                <p v-for="(v,i) in val.lValText" :key="i">
                                    {{v.val}}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <p class="bottomT" v-show="item.flag">欢迎您将简历投递至HR邮箱<span>limin@houselai.com</span>，我们会及时查看并给予您反馈</p>
                <!--按钮-->
                <img src="../../../assets/img/aboutAndJoinUs/按钮-展开.png" class="workBtn" v-show="!item.flag"/>
                <img src="../../../assets/img/aboutAndJoinUs/按钮-收起.png" class="workBtn" v-show="item.flag"/>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "joinUs",
        data() {
            return {
                navData: [
                    {navName: "所有岗位"},
                    {navName: "技术部门"},
                    {navName: "商务部门"},
                    {navName: "运营部门"},
                    {navName: "人力行政"},
                ],
                navIndex: 0,
                allWork: [
                    {
                        title: "商务经理（偏银行方向）",
                        flag: false,
                        dVal: "",
                        lVal: [
                            {
                                name: "「我们一起做这样的事」",
                                lValText: [
                                    {val: "-负责对接各主流银行，主流金融贷款APP，洽谈包括信用卡、贷款在内的各合作项目，争取具有一定市场优势的合作政策"},
                                    {val: "-将合作政策第一时间快速上传下达，配合商务部门做好市场策略的制定"},
                                    {val: "-定期维护合作机构，第一时间掌握市场情况，及时调整合作策略"},
                                    {val: "-负责对接各合作机构的结算，保证合作结算准确、及时"},
                                    {val: "-负责对接部分商务渠道，完成指定的合作目标"},
                                ]
                            },
                            {
                                name: "「我们期待这样的你」",
                                lValText: [
                                    {val: "-「我们期待这样的你」"},
                                    {val: "-热爱商务工作，能从中发现很多乐趣，找到成就感"},
                                    {val: "-聪明伶俐，情商高，有一定的学习能力"},
                                    {val: "-承受得批评，也经得起追捧，始终坚持正向思考"},
                                    {val: "-有事业心，想要追求极致，渴望收获成长，渴望高薪"},
                                ]
                            },
                            {
                                name: "「我们为你提供的」",
                                lValText: [
                                    {val: "-高薪+期权奖励：本岗位薪资不设上限，固定13薪+绩效+年终奖，能力突出者一年之后会分配期权"},
                                    {val: "-发展前景：在对接项目的过程中，成绩优异者可以组建自己的团队，升任管理层"},
                                    {val: "-公司秉持着以人为本的作风，提供更多的时间以及机会帮助大家在激烈的市场竞争中提升自己的硬实力，每月开展读书会活动，一起武装大脑"},
                                    {val: "-多样的团建活动，包含海钓、徒步、爬山、篮球、旅游等等，希望你在工作之余也能体验生活的乐趣！"},
                                    {val: "-如果你怀揣鸿鹄之志，不安于平淡无奇的生活，如果你满身本领，公司将是你坚强的后盾，支持你裂变式创业！"},
                                    {val: "-期待优秀的你加入羽拾这个朝气蓬勃的大家庭"},
                                ]
                            },
                        ]
                    },
                    {
                        title: "广告优化师",
                        flag: false,
                        dVal: "股权激励,年终奖,空间发展大,牛人领导",
                        lVal: [
                            {
                                name: "「我们一起做这样的事」",
                                lValText: [
                                    {val: "-准确了解客户需求，制定相应的广告优化策略，通过媒体进行投放"},
                                    {val: "-主要负责包括广点通、今日头条、百度、搜狗等渠道进行账户投放，制定相应的投放计划，包含投放预算、目标以及账户维护管理"},
                                    {val: "-实时监控分析广告投放的效果，通过数据分析，优化后台数据，提升转化率，降低转化成本 ，实现运营目标"},
                                    {val: "-负责文案以及素材的构思，定期分析媒介投放情况以及对于投放产品进行客观的投产情况分析"},
                                    {val: "-负责对接部分商务渠道，完成指定的合作目标"},
                                ]
                            },
                            {
                                name: "「我们期待这样的你」",
                                lValText: [
                                    {val: "-熟悉并操作过广点通、 朋友圈、今日头条、抖音等渠道账户，至少1 年以上操作经验"},
                                    {val: "-具备良好的的运营策划能力、数据分析能力、文案能力及沟通能力"},
                                    {val: "-有极强的上进心，充满激情与活力，学习能力强，有独立思考并且解决问题的能力"},
                                    {val: "-有关注互联网、广告等行业资讯，具备市场敏感度"},
                                    {val: "-抗压能力强，有创业精神者"},
                                ]
                            },
                            {
                                name: "「我们为你提供的」",
                                lValText: [
                                    {val: "-期权奖励：公司给每一位员工提供舞台，可以施展自己的才华，定期评估并且提供晋升机会，并且给予优秀员工期权奖励，参与公司年底分红，能力决定位置"},
                                    {val: "-充足的预算可以让你更加大胆的去测试媒体渠道，积累经验，迅速成长"},
                                    {val: "-每月开展读书会活动，协助大家做好职业规划以及认知提升，陪伴你一起武装大脑"},
                                    {val: "-多样的团建活动，包含海钓、徒步、爬山、篮球、旅游等等，玩也要玩的出类拔萃"},
                                    {val: "-「我们的团队」"},
                                    {val: "-如果你有着一颗不平凡的心，想要成为更加优秀的自己，有信心成为公司不可或缺的重要组成部分，我们期待着你的加入！"},
                                ]
                            },
                        ]
                    },
                    {
                        title: "行政助理",
                        flag: false,
                        dVal: "股权激励,年终奖,绩效奖金",
                        lVal: [
                            {
                                name: "「我们一起做这样的事」",
                                lValText: [
                                    {val: "-协助公司团队的有效运作，参与公司行政、采购事务管理。"},
                                    {val: "-协助完成公司行政工作，负责公司日常资料收集、档案管理、文书起草、公文制定等"},
                                    {val: "-协助审核、修订公司各项管理规章制度，进行日常行政工作的组织与管理"},
                                    {val: "-完成本部门的行政事务工作，为公司人员提供后勤服务"},
                                    {val: "-协助公司技术部门对接申报专利及政府项目的申报事宜"},
                                    {val: "-完成领导交给的其他任务"},
                                ]
                            },
                            {
                                name: "「我们期待这样的你」",
                                lValText: [
                                    {val: "-本科及以上学历，1-3年工作经验，行政管理、文秘、人力资源管理、财务等相关专业，可接受优秀应届毕业生"},
                                    {val: "-熟练使用office办公软件，具备优秀的书面写作与表达能力"},
                                    {val: "-善于沟通交流，熟悉行政事项办事流程"},
                                    {val: "-出色的组织能力，具备极强的责任心和快速学习能力"},
                                    {val: "-工作积极主动，思维活跃为佳，善于发现问题并提出解决方案"},
                                    {val: "-如果你有着一颗不平凡的心，想要成为更加优秀的自己，有信心成为公司不可或缺的重要组成部分，我们期待着你的加入！"},
                                ]
                            },
                        ]
                    },
                    {
                        title: "PHP开发工程师",
                        flag: false,
                        dVal: "权激励,年终奖,空间发展大,牛人领导",
                        lVal: [
                            {
                                name: "「我们一起做这样的事」",
                                lValText: [
                                    {val: "-负责公司产品的后端PHP"},
                                    {val: "-参与公司产品的讨论设计，给出相应的解决方案"},
                                    {val: "-完成整个产品的生命周期的开发、测试、上线及维护工作"},
                                    {val: "-负责区块链平台以及区块链游戏平台后端的开发和区块链的接口对接"},
                                ]
                            },
                            {
                                name: "「我们期待这样的你」",
                                lValText: [
                                    {val: "-本科及以上学历，计算机相关专业，2~4年PHP开发经验"},
                                    {val: "-熟悉PHP开发，熟悉thinkPHP开发，熟悉TP5者优先考虑"},
                                    {val: "-熟悉Linux操作系统，具备软件安装配置、系统调优、程序部署和运维的能力"},
                                    {val: "-具备较强的自学能力、沟通能力，具备团队协作精神，有解决工作中难题的能力"},
                                    {val: "-熟悉mysql、能熟练编写调试sql语句、存储过程、索引、性能优化"},
                                    {val: "-了解JavaScript、了解基本的jquery"},
                                ]
                            },
                            {
                                name: "「我们为你提供的」",
                                lValText: [
                                    {val: "-「我们为你提供的」"},
                                    {val: "-期权奖励：公司给每一位员工提供舞台，可以施展自己的才华，定期评估并且提供晋升机会，并且给予优秀员工期权奖励，参与公司年底分红，能力决定位置"},
                                    {val: "-每月开展读书会活动，协助大家做好职业规划以及认知提升，陪伴你一起武装大脑"},
                                    {val: "-多样的团建活动，包含海钓、徒步、爬山、篮球、旅游等等，玩也要玩的出类拔萃"},
                                    {val: "-如果你有着一颗不平凡的心，想要成为更加优秀的自己，有信心成为公司不可或缺的重要组成部分，我们期待着你的加入！"},
                                ]
                            },
                        ]
                    },
                ],
                workData: [
                    {
                        title: "商务经理（偏银行方向）",
                        flag: false,
                        dVal: "",
                        lVal: [
                            {
                                name: "「我们一起做这样的事」",
                                lValText: [
                                    {val: "-负责对接各主流银行，主流金融贷款APP，洽谈包括信用卡、贷款在内的各合作项目，争取具有一定市场优势的合作政策"},
                                    {val: "-将合作政策第一时间快速上传下达，配合商务部门做好市场策略的制定"},
                                    {val: "-定期维护合作机构，第一时间掌握市场情况，及时调整合作策略"},
                                    {val: "-负责对接各合作机构的结算，保证合作结算准确、及时"},
                                    {val: "-负责对接部分商务渠道，完成指定的合作目标"},
                                ]
                            },
                            {
                                name: "「我们期待这样的你」",
                                lValText: [
                                    {val: "-「我们期待这样的你」"},
                                    {val: "-热爱商务工作，能从中发现很多乐趣，找到成就感"},
                                    {val: "-聪明伶俐，情商高，有一定的学习能力"},
                                    {val: "-承受得批评，也经得起追捧，始终坚持正向思考"},
                                    {val: "-有事业心，想要追求极致，渴望收获成长，渴望高薪"},
                                ]
                            },
                            {
                                name: "「我们为你提供的」",
                                lValText: [
                                    {val: "-高薪+期权奖励：本岗位薪资不设上限，固定13薪+绩效+年终奖，能力突出者一年之后会分配期权"},
                                    {val: "-发展前景：在对接项目的过程中，成绩优异者可以组建自己的团队，升任管理层"},
                                    {val: "-公司秉持着以人为本的作风，提供更多的时间以及机会帮助大家在激烈的市场竞争中提升自己的硬实力，每月开展读书会活动，一起武装大脑"},
                                    {val: "-多样的团建活动，包含海钓、徒步、爬山、篮球、旅游等等，希望你在工作之余也能体验生活的乐趣！"},
                                    {val: "-如果你怀揣鸿鹄之志，不安于平淡无奇的生活，如果你满身本领，公司将是你坚强的后盾，支持你裂变式创业！"},
                                    {val: "-期待优秀的你加入羽拾这个朝气蓬勃的大家庭"},
                                ]
                            },
                        ]
                    },
                    {
                        title: "广告优化师",
                        flag: false,
                        dVal: "股权激励,年终奖,空间发展大,牛人领导",
                        lVal: [
                            {
                                name: "「我们一起做这样的事」",
                                lValText: [
                                    {val: "-准确了解客户需求，制定相应的广告优化策略，通过媒体进行投放"},
                                    {val: "-主要负责包括广点通、今日头条、百度、搜狗等渠道进行账户投放，制定相应的投放计划，包含投放预算、目标以及账户维护管理"},
                                    {val: "-实时监控分析广告投放的效果，通过数据分析，优化后台数据，提升转化率，降低转化成本 ，实现运营目标"},
                                    {val: "-负责文案以及素材的构思，定期分析媒介投放情况以及对于投放产品进行客观的投产情况分析"},
                                    {val: "-负责对接部分商务渠道，完成指定的合作目标"},
                                ]
                            },
                            {
                                name: "「我们期待这样的你」",
                                lValText: [
                                    {val: "-熟悉并操作过广点通、 朋友圈、今日头条、抖音等渠道账户，至少1 年以上操作经验"},
                                    {val: "-具备良好的的运营策划能力、数据分析能力、文案能力及沟通能力"},
                                    {val: "-有极强的上进心，充满激情与活力，学习能力强，有独立思考并且解决问题的能力"},
                                    {val: "-有关注互联网、广告等行业资讯，具备市场敏感度"},
                                    {val: "-抗压能力强，有创业精神者"},
                                ]
                            },
                            {
                                name: "「我们为你提供的」",
                                lValText: [
                                    {val: "-期权奖励：公司给每一位员工提供舞台，可以施展自己的才华，定期评估并且提供晋升机会，并且给予优秀员工期权奖励，参与公司年底分红，能力决定位置"},
                                    {val: "-充足的预算可以让你更加大胆的去测试媒体渠道，积累经验，迅速成长"},
                                    {val: "-每月开展读书会活动，协助大家做好职业规划以及认知提升，陪伴你一起武装大脑"},
                                    {val: "-多样的团建活动，包含海钓、徒步、爬山、篮球、旅游等等，玩也要玩的出类拔萃"},
                                    {val: "-「我们的团队」"},
                                    {val: "-如果你有着一颗不平凡的心，想要成为更加优秀的自己，有信心成为公司不可或缺的重要组成部分，我们期待着你的加入！"},
                                ]
                            },
                        ]
                    },
                    {
                        title: "行政助理",
                        flag: false,
                        dVal: "股权激励,年终奖,绩效奖金",
                        lVal: [
                            {
                                name: "「我们一起做这样的事」",
                                lValText: [
                                    {val: "-协助公司团队的有效运作，参与公司行政、采购事务管理。"},
                                    {val: "-协助完成公司行政工作，负责公司日常资料收集、档案管理、文书起草、公文制定等"},
                                    {val: "-协助审核、修订公司各项管理规章制度，进行日常行政工作的组织与管理"},
                                    {val: "-完成本部门的行政事务工作，为公司人员提供后勤服务"},
                                    {val: "-协助公司技术部门对接申报专利及政府项目的申报事宜"},
                                    {val: "-完成领导交给的其他任务"},
                                ]
                            },
                            {
                                name: "「我们期待这样的你」",
                                lValText: [
                                    {val: "-本科及以上学历，1-3年工作经验，行政管理、文秘、人力资源管理、财务等相关专业，可接受优秀应届毕业生"},
                                    {val: "-熟练使用office办公软件，具备优秀的书面写作与表达能力"},
                                    {val: "-善于沟通交流，熟悉行政事项办事流程"},
                                    {val: "-出色的组织能力，具备极强的责任心和快速学习能力"},
                                    {val: "-工作积极主动，思维活跃为佳，善于发现问题并提出解决方案"},
                                    {val: "-如果你有着一颗不平凡的心，想要成为更加优秀的自己，有信心成为公司不可或缺的重要组成部分，我们期待着你的加入！"},
                                ]
                            },
                        ]
                    },
                    {
                        title: "PHP开发工程师",
                        flag: false,
                        dVal: "权激励,年终奖,空间发展大,牛人领导",
                        lVal: [
                            {
                                name: "「我们一起做这样的事」",
                                lValText: [
                                    {val: "-负责公司产品的后端PHP"},
                                    {val: "-参与公司产品的讨论设计，给出相应的解决方案"},
                                    {val: "-完成整个产品的生命周期的开发、测试、上线及维护工作"},
                                    {val: "-负责区块链平台以及区块链游戏平台后端的开发和区块链的接口对接"},
                                ]
                            },
                            {
                                name: "「我们期待这样的你」",
                                lValText: [
                                    {val: "-本科及以上学历，计算机相关专业，2~4年PHP开发经验"},
                                    {val: "-熟悉PHP开发，熟悉thinkPHP开发，熟悉TP5者优先考虑"},
                                    {val: "-熟悉Linux操作系统，具备软件安装配置、系统调优、程序部署和运维的能力"},
                                    {val: "-具备较强的自学能力、沟通能力，具备团队协作精神，有解决工作中难题的能力"},
                                    {val: "-熟悉mysql、能熟练编写调试sql语句、存储过程、索引、性能优化"},
                                    {val: "-了解JavaScript、了解基本的jquery"},
                                ]
                            },
                            {
                                name: "「我们为你提供的」",
                                lValText: [
                                    {val: "-「我们为你提供的」"},
                                    {val: "-期权奖励：公司给每一位员工提供舞台，可以施展自己的才华，定期评估并且提供晋升机会，并且给予优秀员工期权奖励，参与公司年底分红，能力决定位置"},
                                    {val: "-每月开展读书会活动，协助大家做好职业规划以及认知提升，陪伴你一起武装大脑"},
                                    {val: "-多样的团建活动，包含海钓、徒步、爬山、篮球、旅游等等，玩也要玩的出类拔萃"},
                                    {val: "-如果你有着一颗不平凡的心，想要成为更加优秀的自己，有信心成为公司不可或缺的重要组成部分，我们期待着你的加入！"},
                                ]
                            },
                        ]
                    },
                ]
            }
        },
        mounted() {
            /*淡入淡出效果*/
            window.addEventListener('scroll', this.scrollFun);
            this.scrollFun();
        },
        methods: {
            showValEvent(item) {
                item.flag = !item.flag;
            },
            /*导航切换事件，此处变更 workData 变量实现岗位切换*/
            navEvent(index) {
                this.navIndex = index;
                this.workData = [];
                switch (index) {
                    case 0:
                        this.workData = this.allWork;
                        break;
                    case 1:
                        this.workData.push(this.allWork[3]);
                        break;
                    case 2:
                        this.workData.push(this.allWork[0]);
                        break;
                    case 3:
                        this.workData.push(this.allWork[1]);
                        break;
                    case 4:
                        this.workData.push(this.allWork[2]);
                        break;
                }
            },
            scrollFun() {
                this.$animate(document.getElementById("joinUs"), "fadeInUp");
            }
        },
        beforeDestroy() {
            /*销毁监听*/
            window.removeEventListener('scroll', this.scrollFun);
        }
    }
</script>

<style lang="scss" scoped>
    #joinUs {
        display: flex;
        justify-content: space-between;
        width: 1200px;
        padding-top: 112px;
        margin: 0 auto;

        .leftNav {
            width: 260px;
            margin-right: 40px;

            .navBox {
                display: flex;
                align-items: center;
                height: 60px;
                margin-bottom: 18px;
                cursor: pointer;
                font-size: 20px;
                padding-left: 40px;
                color: #152346;

                span {
                    display: inline-block;
                    width: 8px;
                    height: 8px;
                    border-radius: 50%;
                    margin-right: 16px;
                    background: #fff;
                }
            }

            .activeC {
                background: #F6F9FF;

                span {
                    background: #000 !important;
                }
            }
        }

        .rightCon {
            flex: 1;

            .workList {
                position: relative;
                cursor: pointer;
                background: #F6F9FF;
                border-radius: 2px;
                padding: 18px 84px 0 30px;
                margin-bottom: 20px;

                .workBtn {
                    position: absolute;
                    right: 30px;
                    top: 48px;
                }

                .workTitle {
                    opacity: 0.6;
                    padding-bottom: 13px;
                    margin-bottom: 12px;
                    font-size: 20px;
                    color: #152346;
                    letter-spacing: 0;
                    border-bottom: 1px solid rgba(21, 35, 70, .1);
                }

                .activeT {
                    opacity: 1;
                }

                .dVal {
                    opacity: 0.6;
                    padding-bottom: 20px;
                    font-size: 12px;
                    color: #152346;
                    letter-spacing: 0;
                    text-align: justify;
                    line-height: 22px;
                }

                .lValWrap {
                    .lValBox {
                        margin-bottom: 20px;

                        .lValTitle {
                            font-weight: bold;
                            opacity: 0.7;
                            margin-bottom: 4px;
                            font-size: 14px;
                            color: #152346;
                            letter-spacing: 0;
                            text-align: justify;
                            line-height: 22px;
                        }

                        .lValText {
                            opacity: 0.7;
                            font-size: 14px;
                            color: #152346;
                            letter-spacing: 0;
                            text-align: justify;
                            line-height: 22px;
                            margin-bottom: 20px;
                        }
                    }
                }

                .btn {
                    width: 72px;
                    height: 32px;
                    border: 1px solid #58637D;
                    font-size: 13px;
                    color: #152346;
                    background: transparent;
                    cursor: pointer;
                    border-radius: 4px;
                }

                .bottomT {
                    opacity: 0.7;
                    font-size: 14px;
                    color: #152346;
                    text-align: justify;
                    line-height: 22px;
                    font-weight: bold;
                    padding-bottom: 50px;

                    span {
                        color: #4161FF;
                    }
                }
            }
        }
    }
</style>
